import type { FlowId } from '../../types';
import type { SelfServiceApiContext } from './types';
import { runWithSpan } from './tracing';

export const getSignUrl = async (ctx: SelfServiceApiContext, sessionId: string, flowId?: FlowId): Promise<{ signUrl: string }> => {
  return runWithSpan('api.getSignUrl', async span => {
    span.setAttribute('session.id', sessionId);
    await ctx.delay(ctx.config.delays.getSignUrl);

    const suffix = flowId ? `?flow=${encodeURIComponent(flowId)}` : '';

    const response = await ctx.httpClient.getJSON(`${ctx.baseUrl}/selfservice/${sessionId}/sign-url${suffix}`, {
      maxRetries: 3,
      onRetry: (attempt: number) => console.log(`Retrying getSignUrl... attempt ${attempt}`)
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(`Failed to fetch sign URL: ${response.status} ${error}`);
    }

    return response.json();
  });
};
